<template>
  <div>
    <topbar title="Crediti" :showBack="true" :largeTitle="true"  @back="$router.go(-1)" />
    
    <div v-once class="p-3 max-w-3xl mx-auto w-full">
      <p>
        <i>lìdatè</i> è un progetto di ricerca e di divulgazione sociolinguistica nato dall’iniziativa dell’Osservatorio linguistico della Svizzera italiana (OLSI) e sviluppato assieme al Laboratorio cultura visiva della Scuola universitaria professionale della Svizzera italiana (SUPSI).
      </p>
      <p>
        Per saperne di più visita <a href="https://www.lidate.ch" target="_blank" class="underline">www.lidate.ch</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  }
</script>

<style>
</style>